<template>
  <div class="column-design-idea">
    <div class="design-idea-title select-all">
      <span class="select-all">{{ design.name }}</span>
      <i class="ti ti-printer mr-1 print-content" @click.prevent="handlePrint"></i>
    </div>
    <div class="design-idea-thumbnail" :data-id="design.id" @click="viewDesignIdea">
      <Image :src="$util.addQueryParam(design.thumbnail, { size: 'xs' })" />
    </div>
    <div class="design-idea-main">
      <div class="design-idea-summary">
        <div class="idea-creator">
          <label>Creator:&nbsp;</label>
          <span class="select-all">{{ design.user_name || '-' }}</span>
          <span v-if="parseInt(design.date_created) > 0" v-html="` [${$util.timestampToDateTime(parseInt(design.date_created))}]`"></span>
        </div>
        <div class="designer">
          <label>Designer:&nbsp;</label>
          <span class="select-all">{{ design?.designer_name || '-' }}</span>
          <span v-html="timeRangeStatus('doing')"></span>
        </div>
        <div v-html="displayUser('design-review', 'Design Reviewer')"></div>
        <div v-html="displayUser('create-demo', 'Demo Creator')"></div>
        <div v-html="displayUser('demo-review', 'Demo Reviewer')"></div>
        <div v-html="displayUser('create-mockup', 'Mockup Creator')"></div>
        <div v-html="displayUser('mockup-review', 'Mockup Reviewer')"></div>
        <div class="status raw">
          <label>Status:&nbsp;</label>
          <span>{{ design.status_label }}</span>
        </div>

        <div class="row-actions break-normal">
          <span v-for="(action, key, index) in item.actions" :key="index" :class="[action.id.replace('.', '-'), action.style || '']">
            <a href="#" :aria-label="action.label" @click.prevent="handleAction(item, action)">
              {{ action.label }}
            </a>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BodyItemRowAction from '@/components/TableList/Cols/BodyItemRowAction.vue'
import print from '@/helper/print.js'
export default {
  extends: BodyItemRowAction,
  computed: {
    store() {
      return this.config?.store
    },
    design() {
      return Object.assign(
        {
          users: {}
        },
        _.isObjectLike(this.item.design) ? this.item.design : {}
      )
    }
  },
  methods: {
    viewDesignIdea(e) {
      this.$emitter.emit('Modal', {
        name: 'design-idea.view',
        $el: e.currentTarget.closest('tr.item'),
        data: this.row
      })
    },
    displayUser(status, label) {
      if (!this.design?.users?.[status]?.user_name) return
      return `<div class="${status}">
        <label>${label}:&nbsp;</label>
        <span class="select-all">${this.design?.users?.[status].user_name}</span>
        <span>${this.timeRangeStatus(status)}</span>
      </div>`
    },
    timeRangeStatus(status) {
      if (!this.design.users[status]?.start) return ''
      return ` [${this.$util.timestampToDateTime(parseInt(this.design.users[status]?.start))}${parseInt(this.design?.users?.[status]?.end) > 0 ? ' - ' + this.$util.timestampToDateTime(parseInt(this.design.users[status].end)) : ''}]`
    },
    handlePrint() {
      print.designIdea([this.item?.design])
    }
  }
}
</script>

<style lang="scss">
.column-design-idea {
  padding: 15px;
  display: flex;
  flex-wrap: wrap;
  .design-idea-title {
    font-weight: bold;
    margin-bottom: 10px;
    width: 100%;
  }
  .design-idea-thumbnail {
    width: 200px;
    height: 200px;
    float: left;
    margin-right: 15px;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .design-idea-main {
    flex: 1;
    display: flex;
    /* .design-idea-summary {
      width: 250px;
    } */
    .design-idea-meta {
      flex: 1;
    }
  }
  .print-content {
    cursor: pointer;
    font-size: 16px;
    margin: 0 5px;
    margin-top: -1px;
    display: none;
  }
  &:hover {
    .print-content {
      display: inline-block;
    }
  }
}
</style>
